<template>
  <div>
    <h4>{{ done ? 'Klart' : 'Lyssnar efter brandvarnare...' }}</h4>
    
    <p>Din Nexa Bridge lyssnar just nu efter brandvarnare. Sätt din brandvarnare i testläge för att kunna lägga in den i Bridge, när den detekteras kommer du att skickas vidare till nästa steg.</p>
    
    <p><strong>Observera nedanstående.</strong></p>
    
    <p>Om dina brandvarnare är sammankopplade kommer du <i>inte</i> att kunna lägga till dessa separat i din Nexa Bridge utan då räcker det att du lägger till en eftersom alla brandvarnare använder sig av samma identifieringskod när de larmar.</p>
    
    <p>Vill du lägga till varje brandvarnare separat får de inte vara kopplade med varandra.</p>
    
    
    <p v-if="done">Hittade en brandvarnare med adress: <strong>{{ address }}</strong></p>
    
    <div style="text-align:center;">
      <div v-if="!done"><img src="../assets/fire.gif" width="200"></div>
      <div v-if="done"><img src="../assets/check2.gif" width="350"></div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { HalfCircleSpinner } from 'epic-spinners'
  import { eventbus } from '../eventbus.js'
  
  export default {
    name: 'HelloWorld',
    components: {
      HalfCircleSpinner
    },
    data () {
      return {
        address: 0
      }
    },
    methods: {},
    created () {
      // Återställ vår temporära sparning
      this.$root.tempSaveStore = {}

      HTTP.post('nodeops/listenGarvan')
      .then(res => res.data)
      .then(json => {})
      
      // Lyssna efter signaler från Bridgen
      eventbus.$once('garvanCode', (json) => {
        this.address = json.address

        // Vänta 2s innan vi skickar vidare användaren 
        setTimeout(() => {
          this.$root.tempSaveStore = {
            capabilities: ['notificationSmoke'],
            address: this.address,
            type: 'GarvanAlarm'
          }

          this.$router.push({
            name: 'save_node'
          })
        }, 2500)
      })
    },
    
    computed: {
      done () {
        return this.address > 0   
      }
    },
  
    destroyed () {
      eventbus.$off('garvanCode')
      HTTP.post('nodeops/listenGarvanAbort')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/add_firesafety.vue